<template>
  <div class="wrapper mt-10" style="margin-bottom: 150px">
    <div class="wrapper-login-box">
      <h2>Register</h2>
      <ValidationObserver ref="observer">
        <div class="mt-4">
          <div class="mb-2">
            <ValidationProvider name="ชื่อ" :rules="'required'" v-slot="{ errors }">
              <h4 class="my-1">Name</h4>
              <v-text-field
                v-model="input.name"
                placeholder="Name"
                dense
                type="text"
                outlined
                clearable
                required
                @click:clear="$emit('input', null)"
                :hide-details="errors.length ? false : true"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class="mb-2">
            <ValidationProvider
              name="เบอร์โทรศัพท์"
              :rules="'required|thai_phonenumber'"
              v-slot="{ errors }"
            >
              <h4 class="my-1">Phone No.</h4>
              <ThaiPhoneNumber v-model="input.phone_number" :errors="errors"></ThaiPhoneNumber>
            </ValidationProvider>
          </div>
          <div class="d-flex flex-column">
            <v-layout row justify-center align-center class="my-3">
              <vue-recaptcha
                ref="recaptcha"
                :key="`recaptcha_${timestamp}`"
                @verify="verifyRecapcha"
                :loadRecaptchaScript="true"
                :sitekey="setting.googleRecaptchaSiteKey"
              >
              </vue-recaptcha>
            </v-layout>
            <v-btn
              :disabled="!tokenRecap"
              ref="regisbtn"
              @click="regis"
              class="mx-0 mx-md-5 mt-5 py-7"
              style="color: white"
              depressed
              large
              :loading="loading"
              color="#1D92E1"
              rounded
              >Register</v-btn
            >
            <div v-if="errorMessage" class="red--text text-center pa-3 mt-2">
              * {{ errorMessage }}
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import sprcApi from '@/api/sprc'
import ThaiPhoneNumber from '@/components/ThaiPhoneNumber.vue'
// import PasswordInput from '@/components/PasswordInput.vue'
import { VueRecaptcha } from 'vue-recaptcha'
import moment from 'moment'
import { mapGetters } from 'vuex'
// import swal from 'sweetalert2'

export default {
  components: {
    ThaiPhoneNumber,
    VueRecaptcha
    // PasswordInput
  },
  data() {
    return {
      input: {
        name: '',
        phone_number: '',
        password: '',
        checkbox: false
      },
      tokenRecap: '',
      loading: false,
      rememberme: false,
      recaptcha: undefined,
      timestamp: moment().format('x'),
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['setting'])
  },
  beforeCreate() {
    this.$store.state.bgcolor = '#efefef'
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  methods: {
    verifyRecapcha(response) {
      this.tokenRecap = response
    },
    goTo(path) {
      // this.$store.state.page = path
      this.$store.dispatch('setPage', path)
    },
    handleOpenExternal(url) {
      window.open(url, '_blank')
    },
    async getToken() {
      try {
        const resData = await sprcApi.getToken()
        if (resData?.data?.data?.access_token) {
          return resData.data.data.access_token
        }
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async regis() {
      let vm = this
      let token = this.tokenRecap
      if (token) {
        await vm.$refs.observer.validate().then((result) => {
          if (!result) {
            vm.resetRecaptcha()
            return false
          }

          vm.$store.state.recaptchaToken = token
          vm.onSubmit(token)
        })
      }
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset()
      this.timestamp = moment().format('x')
    },
    async onSubmit(token) {
      const vm = this
      if (await vm.$refs.observer.validate()) {
        let data = {
          pageId: vm.$store.getters.setting.pageid,
          phone_number: vm.input.phone_number,
          password: vm.input.password,
          name: vm.input.name,
          g_recaptcha_response: token
        }
        try {
          vm.loading = true
          const access_token = await this.getToken()
          const resData = await sprcApi.regis(data, access_token)
          if (resData && resData.data && resData.data.userid) {
            this.$store.state.id = resData.data.userid
            localStorage.setItem('id', this.$store.state.id)
            await this.chatlog(this.$store.state.id, this.$store.getters.setting.pageid)
            this.$store.state.isJustLogin = true

            this.$store.commit('SET_LOGIN_STATUS', true)
            vm.errorMessage = null
          }
        } catch (error) {
          vm.loading = false
          vm.resetRecaptcha()
          console.error(error)
          if (error.response) {
            vm.errorMessage = error.response.data.message
          }
        } finally {
          vm.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
